<!--
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2021-04-08 09:30:28
-->
<template>
  <el-dialog
    :visible.sync="errorDialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="35%"
    center
  >
    <error-view
      @confirm="confirm"
      :text="errorMessage"
      :buttonTitle="errorButtonTitle"
    />
  </el-dialog>
</template>
<script>
import ErrorView from '@/components/ErrorAlertView'
export default {
  components: {
    ErrorView
  },
  data () {
    return {
      errorMessage: '非常抱歉，登录页参数丢失，点击关闭按钮将会关闭此页面，如有疑问请咨询系统管理员',
      errorButtonTitle: '关闭',
      errorDialogVisible: true
    }
  },
  methods: {
    confirm () {
      window.opener = null
      window.open('', '_self')
      window.close()
      window.location.href = document.referrer
      window.history.back(-1)
    }
  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/notFound.vue